import { makeStyles } from "tss-react/mui";
import { MiBox } from "@miplatform/components";
import { Box } from "@mui/system";

export const SidebarLayout = ({
  children,
  sidebarContent,
}: {
  children?: React.ReactNode;
  sidebarContent?: React.ReactNode;
}) => {
  const { classes } = useStyles();

  return (
    <MiBox className={classes.contentContainer}>
      <Box className={classes.mainContentContainer}>{children}</Box>
      <Box className={classes.sidebarContainer}>{sidebarContent}</Box>
    </MiBox>
  );
};

const useStyles = makeStyles()((theme) => ({
  contentContainer: {
    display: "flex",
    flexDirection: "row",
    flex: 1,
    height: "100%",
    overflow: "hidden",
    padding: theme.spacing(4),
    gap: theme.spacing(4),
  },
  sidebarContainer: {
    minWidth: 250,
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
    backgroundColor: theme.palette.grey.lightAccent,
    padding: theme.spacing(2),
    borderRadius: theme.spacing(1),
  },
  mainContentContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
}));
